import { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa6";
import LoadingMiniSpinner from "src/components/LoadingMiniSpinner/LoadingMiniSpinner";
import { notify } from "src/services/Notification/Notification";
import num2wordsFa from "src/utils/num2wordsFa";

export default function InputBox({ defaultValue, isMinify = false, handleClick = async () => { }, type = "text" }) {
    const [updatedValue, setUpdatedValue] = useState(defaultValue)
    const [isChanged, setIsChanged] = useState(false);
    const [value, setValue] = useState(defaultValue);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async () => {
        setUpdatedValue(value)
        setIsLoading(true);
        setIsChanged(false);
        try {
            await handleClick(value);
            notify("تغییرات با موفقیت انجام شد", "success")
        } catch (err) {
            setUpdatedValue("")
            console.error("Error:", err);
            notify("خطایی رخ داده است", "error")
        } finally {
            setIsLoading(false);
        }
    };



    return (
        <div className={`relative flex flex-col items-start justify-end gap-1 ${!isMinify ? " w-[200px]" : ""}`}>

            <div className="w-full border border-gray-300 rounded-lg flex items-center justify-center bg-white">
                <input
                    className="p-2 rounded-lg w-full no-spinner text-base "
                    type={type}
                    inputMode="numeric"
                    value={value ? value.toLocaleString() : undefined}
                    onChange={(e) => {
                        setValue(parseInt(String(e.target.value).replace(/,/g, "")));
                        setIsChanged(true);
                    }}
                    onBlur={() => {
                        if (!value && value != 0) {
                            setValue(updatedValue);
                            setIsChanged(false);
                        }
                    }}
                />

                {isLoading ? (
                    <div className="px-2">
                        <LoadingMiniSpinner className="px-2 w-[30px]" />
                    </div>
                ) : isChanged ? (
                    <FaCheck
                        className="px-2 w-[30px] cursor-pointer"
                        onClick={handleSubmit}
                    />
                ) : null}
            </div>
            {
                isChanged && (
                    <div className="text-sm text-red-500 absolute top-11 w-[250px]">
                        {num2wordsFa(parseInt(value))}
                    </div>
                )
            }
        </div>
    );
}
